import { init } from "../init";
import { JiraTemplateCategoryPage } from "../pages/software/jira/templates/service-management/jira-template-category-page";

init(JiraTemplateCategoryPage);
